<ng-container [formGroup]="form">
  <div class="grid-x grid-margin-x" [ngClass]="{ 'border-top': point != types.WellHead }">
    <div class="cell large-12 medium-12 small-12 bold">
      {{locationPoint}}
    </div>
    <div class="cell small-6 medium-3 large-3 bold text-align-right padding-right">
      GPS NAD83 Latitude:
      @if (fieldHasNotes(getFieldName('latitude')) || reviewStates?.includes(applicationState)) {
        <span class="padding-left">
          <view-notes [fieldName]="getFieldName('latitude')" [notes]="getFilteredNotes(getFieldName('latitude'))" (notesRequested)="handleNoteRequested($event)"></view-notes>
        </span>
      }
    </div>
    <div class="cell small-6 medium-2 large-2 text-align-left">
      <input type="number" formControlName="latitude" (ngModelChange)="invalidate()" (blur)="roundCoordinate('latitude')" />
    </div>
    <div class="cell small-6 medium-3 large-3 bold text-align-right padding-right">
      GPS NAD83 Longitude:
      @if (fieldHasNotes(getFieldName('longitude')) || reviewStates?.includes(applicationState)) {
        <span class="padding-left">
          <view-notes [fieldName]="getFieldName('longitude')" [notes]="getFilteredNotes(getFieldName('longitude'))" (notesRequested)="handleNoteRequested($event)"></view-notes>
        </span>
      }
    </div>
    <div class="cell small-6 medium-2 large-2 text-align-left">
      <input type="number" formControlName="longitude" (ngModelChange)="invalidate()" (blur)="roundCoordinate('longitude')" />
    </div>
    <div class="cell small-12 medium-2 large-2">
      <button class="button" (click)="validate()" [disabled]="disableValidate">Validate</button><span class="padding-left" style="vertical-align: top; display: inline-block;"><help-text [helpText]="validationHelpText" [alert]="pointValidationRequired"></help-text></span>
    </div>
    <div class="cell small-12 medium-6 large-6 bold text-align-right padding-right">
      <div class="grid-x">
        <div class="cell small-12 medium-12 large-12 bold text-align-center">
          County:
        </div>
        <div class="cell small-6 medium-2 large-2 bold padding-right text-align-right">
          Name:
        </div>
        <div class="cell small-6 medium-4 large-4 padding-left">
          <input type="text" formControlName="countyName" />
        </div>
        <div class="cell small-6 medium-3 large-3 bold padding-right text-align-right">
          Number:
        </div>
        <div class="cell small-6 medium-3 large-3 padding-left">
          <input type="text" formControlName="countyNumber" />
        </div>
      </div>

    </div>
    <div class="cell small-12 medium-6 large-6 bold text-align-right padding-right">
      <div class="grid-x">
        <div class="cell small-12 medium-12 large-12 bold text-align-center">
          Township:
        </div>
        <div class="cell small-6 medium-2 large-2 bold padding-right text-align-right">
          Name:
        </div>
        <div class="cell small-6 medium-4 large-4 padding-left">
          <input type="text" formControlName="townshipName" />
        </div>
        <div class="cell small-6 medium-3 large-3 bold padding-right text-align-right">
          Number:
        </div>
        <div class="cell small-6 medium-3 large-3 padding-left">
          <input type="text" formControlName="townshipNumber" />
        </div>
      </div>

    </div>
    <div class="cell small-12 medium-6 large-6 bold text-align-right padding-right">
      <div class="grid-x">
        <div class="cell small-12 medium-12 large-12 bold text-align-center">
          Quadrangle:
        </div>
        <div class="cell small-6 medium-2 large-2 bold padding-right text-align-right">
          Name:
        </div>
        <div class="cell small-6 medium-4 large-4 padding-left">
          <input type="text" formControlName="quadrangleName" />
        </div>
        <div class="cell small-6 medium-3 large-3 bold padding-right text-align-right">
          Code:
        </div>
        <div class="cell small-6 medium-3 large-3 padding-left">
          <input type="text" formControlName="quadrangleCode" />
        </div>
      </div>
    </div>
    <div class="small-12 medium-6 large-6">
      <div class="grid-x">
        <div class="cell small-6 medium-6 large-6 bold padding-right text-align-right">
          Civil Township Number:
        </div>
        <div class="cell small-6 medium-6 large-6">
          <input type="text" formControlName="civilTownshipNumber" />
        </div>
      </div>
    </div>
    <div class="cell small-6 medium-2 large-2 bold text-align-right padding-right">
      Section:
    </div>
    <div class="cell small-6 medium-2 large-2">
      <input type="text" formControlName="section" />
    </div>
    <div class="cell small-6 medium-2 large-2 bold text-align-right padding-right">
      Lot:
    </div>
    <div class="cell small-6 medium-2 large-2">
      <input type="text" formControlName="lot" />
    </div>
    <div class="cell small-6 medium-2 large-2 bold text-align-right padding-right">
      Tract:
    </div>
    <div class="cell small-6 medium-2 large-2">
      <input type="text" formControlName="tract" />
    </div>
  </div>
</ng-container>
